import styled from 'styled-components';
import COLORS from '../../common/styles/color-pallete';
import { FONT_FAMILY } from '../../common/styles/fontStyles';

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: white;
  border-radius: 12px;
  box-shadow: 0px 10px 24px rgba(0, 0, 0, 0.1);
  padding: 32px 28px 28px;
  width: 380px;
  position: relative;

  @media only screen and (max-width: 480px) {
    width: 90%;
    padding: 28px 20px 24px;
  }
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
`;

export const WarningImgContainer = styled.div`
  margin-bottom: 8px;
`;

export const Title = styled.h2`
  font-family: ${FONT_FAMILY.hellix.bold};
  font-size: 18px;
  font-weight: 700;
  line-height: 26px;
  color: ${COLORS.black};
  text-align: center;
  margin: 16px 0 12px;
`;

export const Description = styled.p`
  font-family: ${FONT_FAMILY.hellix.regular};
  font-size: 18px;
  font-weight: 400;
  line-height: 24px;
  color: ${COLORS.black};
  text-align: center;
  margin: 0 0 24px;
`;

export const GoogleButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  height: 48px;
  border: 1px solid ${COLORS.black};
  border-radius: 8px;
  background: white;
  cursor: pointer;
  font-family: ${FONT_FAMILY.hellix.bold};
  font-size: 14px;
  color: ${COLORS.black};
  margin-bottom: 12px;

  &:hover {
    background: ${COLORS.lightGrey};
  }
`;
